module.exports = __webpack_public_path__ + "static/progressBar-c7e4bb076b03bd54a72b4a6812365ab0.png";